import * as Yup from "yup";

export const cardTokenSchema = Yup.object().shape({
  creditCard: Yup.object().shape({
    holderName: Yup.string().required("Nome do titular é obrigatório"),
    number: Yup.string().required("Número do cartão é obrigatório"),
    expiryMonth: Yup.string().required("Mês de validade é obrigatório"),
    expiryYear: Yup.string().required("Ano de validade é obrigatório"),
    ccv: Yup.string().required("Código de segurança é obrigatório"),
  }),

  customer: Yup.object().shape({
    cpfCnpj: Yup.string().required("CPF ou CNPJ é obrigatório"),
    email: Yup.string()
      .email("E-mail inválido")
      .required("O e-mail do titular é obrigatório"),
  }),
});
